import React from 'react';
import { Box, Text, Link } from '@chakra-ui/react';
import { getTranslations } from '../translations';
import { decode } from '../utils/obfuscate';

const Footer = ({ isDarkMode }) => {
    const t = getTranslations();
    const currentYear = new Date().getFullYear();
    
    // Testi offuscati (base64 di reverse del testo originale)
    const copyrightText = decode('dGVuLm9mZmFyZ29sYiB9cmFleXstMzIwMiDCqQ==');
    const linkText = decode('dGVuLm9mZmFyZ29sYg==');
    const linkUrl = decode('dGVuLm9mZmFyZ29sYi8vOnNwdHRo');

    return (
        <Box
            as="footer"
            w="100%"
            py={4}
            textAlign="center"
            bg="transparent"
            mt="auto"
            pb={8}
        >
            <Text fontSize="xs" color={isDarkMode ? "gray.500" : "gray.400"}>
                {t.version} | {copyrightText.replace('{year}', currentYear)}
            </Text>
            <Link
                href={linkUrl}
                isExternal
                fontSize="xs"
                color={isDarkMode ? "gray.500" : "gray.400"}
                _hover={{ color: "teal.500" }}
            >
                {linkText}
            </Link>
        </Box>
    );
};

export default Footer;
